
import React, { useEffect } from "react";
import { QuizHeaderBarType, QuizPanelHeader, QuizPanelHeaderProps } from "./QuizPanelHeader";
import { QuizAnswerConfig, QuizAnswerType, QuizBankConfig, QuizConfigData, QuizQuestionConfig, QuizResults, QuizTreeConfig } from "../Shared/Party/PartyConfigData";
import { CreateQuiz, Quiz } from "./Quiz";
import { CreateQuestionLayout, QuestionLayout } from "./QuizLayoutEngine";
import { createMeasureContext, MeasureContext } from "./TextLayoutEngine";
import { Generator } from "./Quiz";
import { LandingPage, LandingPageProps } from "./LandingPage";
import { QuizResultsPanel, QuizResultsPanelProps } from "./QuizResultsPanel";
import { UIConfigContext } from "./UIConfigContext";
import { ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";




export type QuizPanelDisplayProps = {
    complete(points: number, time: number): void;
    getGenerator(name: string): Generator;
    imagePadding : number;
    textPadding : number;
    fontbase: number;
    availableHeight: number;
    headerBar: QuizHeaderBarType;
    numberInParty : number;
    quizOpened : number;
    quizCloses : number;
    partyId : string;
}



export type QuizURLMap = {
    urls: Map<string, Map<string, string>>;
}




const QuestionPanel = ({ question, layout }: { question: QuizQuestionConfig, layout: QuestionLayout }): JSX.Element => {
    var inner = new Array<JSX.Element>();

    let qHeight = layout.questionTextHeight + layout.questionImageGridHeight;
    
    if(question.images === undefined)
        question.images = Array<string>();

    if (question.text !== undefined){
        const vertSpace = layout.questionTextHeight -layout.questionInnerTextHeight;
        const topSpace = vertSpace * 0.5;
        const bottomSpace = vertSpace * 0.5;

        inner.push((<span
            style={{
                fontSize: layout.questionFontSize + "px",
                textAlign : 'center',
                paddingTop : topSpace + 'px',
                paddingBottom : bottomSpace + 'px',
                minWidth : layout.width + 'px',
                color : 'white',
            }}>{question.text ?? ""}</span>));
        }

    if (question.images.length > 0) {
        const marginV = ((layout.questionImageGridHeight - layout.imagePadding) / layout.questionImageGrid.rows - layout.questionImageSize.height) * 0.5;
        const marginH = ((layout.width - layout.imagePadding) / layout.questionImageGrid.columns - layout.questionImageSize.width) * 0.5;

        var qGrid = new Array<JSX.Element>();
        for (var i = 0; i < question.images.length; i++) {
            const col = i % layout.questionImageGrid.columns;
            const row = Math.floor(i / layout.questionImageGrid.rows) + 1;
            const marginLeft = marginH + (col === 1 ? layout.imagePadding * 0.5 : 0);
            const marginRight = marginH + (col === layout.questionImageGrid.columns ? layout.imagePadding * 0.5 : 0);
            const marginTop = marginV + (row === 1 ? layout.imagePadding * 0.5 : 0);
            const marginBottom = marginV + (row === layout.questionImageGrid.rows ? layout.imagePadding * 0.5 : 0);
            const imH = layout.questionImageSize.height + "px";
            const imW = layout.questionImageSize.width + "px";
            qGrid.push((<div style={{
                gridColumn: col,
                gridRow: row,
                minHeight: imH,
                height: imH,
                maxHeight: imH,
                minWidth: imW,
                width: imW,
                maxWidth: imW,
                backgroundImage: `url(${question.images[i]})`,
                marginLeft: marginLeft + "px",
                marginTop : marginTop + 'px',
                marginRight : marginRight + 'px',
                marginBottom : marginBottom + 'px'
            }}></div>));
        }



        const grid = ((<div style={{
            display: "grid",
            gridTemplateRows: "auto",
            gridAutoColumns: "auto",
            minHeight: layout.questionImageGridHeight + "px",
            height: layout.questionImageGridHeight + "px",
            maxHeight: layout.questionImageGridHeight + "px",
            minWidth: layout.width + "px",
            width: layout.width + "px",
            maxWidth: layout.width  + "px",
        }}>
            {qGrid}
        </div>));
        inner.push(grid);
    }



    return (<div style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: qHeight + "px",
        height: qHeight + "px",
        maxHeight: qHeight + "px",
        minWidth: layout.width + "px",
        width: layout.width + "px",
        maxWidth: layout.width + "px",
        backgroundColor : '#131313'
    }}>
        {inner}
    </div>);

};

const AnswerPanel = ({ question, currentAnswers, layout, onAnswer }: { question: QuizQuestionConfig, currentAnswers: QuizAnswerConfig[], layout: QuestionLayout, onAnswer: (selected: number[], values: number[]) => void }): JSX.Element => {
    let qHeight = layout.questionTextHeight;
    if(question.answerType === undefined)
        question.answerType = 'select';
    const gHeight = layout.questionImageGrid.rows === 0 ? 0 : layout.questionImageGrid.rows * (layout.questionImageSize.height + layout.imagePadding) + layout.imagePadding;
    qHeight += gHeight;
    const hasText = (()=>{
        var c = false;
        currentAnswers.forEach((answer) => {
            c = c || (answer.text !== undefined);
        });
        return c;
    })();
    const hasImage = (()=>{
        var c = false;
        currentAnswers.forEach((answer) => {
            c = c || (answer.image !== undefined);
        });
        return c;
    })();
    const borderRadius = hasImage ? 0 : 25;
    const border = hasImage ? '0px solid white' : '2px solid red'; 

    const cellHeight = (layout.height - qHeight - layout.imagePadding) / layout.answerGrid.rows;
    const outerMarginTop = (hasText && !hasImage) ? layout.textPadding * 0.5 : 0;
    const outerMarginBottom = (hasText && !hasImage) ? layout.textPadding * 0.5 : 0;
    const outerMarginH =  (hasText && !hasImage) ? layout.imagePadding * 0.5 : 0;

    const innerCellHeight = cellHeight - outerMarginTop - outerMarginBottom;
    const innerCellWidth = (layout.width - layout.imagePadding - outerMarginH * 2) / layout.answerGrid.columns - outerMarginH;

    
    const imagePadH = hasImage ? (innerCellWidth - layout.answerImageSize.width) * 0.5 : 0;



    var aGrid = new Array<JSX.Element>();
    for (var i = 0; i < currentAnswers.length; i++) {
        const index = i;
        const col = i % layout.answerGrid.columns + 1;
        const row = Math.floor(i / layout.answerGrid.columns) + 1;
        const imH = layout.answerImageSize.height + "px";
        const imW = layout.answerImageSize.width + "px";
        const onlyTextMarginV = (innerCellHeight - layout.answerTextHeights[i]) * 0.5 -2;
        //console.log('Rendering Answer Cell r=' + row + ' c=' +col);
        


        const clickHandler = () => {
            onAnswer([index], []);
        }

        if (question.answerType == "select" || question.answerType == "matchAnswer") {
                     
            aGrid.push((<div style={{
                display: 'flex',
                flexDirection: 'column',
                gridColumnStart: col,
                gridColumnEnd : col,
                gridRowStart: row,
                gridRowEnd : row,
                backgroundColor: '#131313',
                borderRadius : borderRadius + 'px',
                border : border,
                marginTop :  outerMarginTop + (row === 1 ? 0.5* layout.imagePadding : 0) + 'px',
                marginBottom : outerMarginBottom + (row === layout.answerGrid.rows ? 0.5* layout.imagePadding : 0) + 'px',
                marginLeft : outerMarginH + (col === 1 ? 0.5* layout.imagePadding : 0) + 'px',
                marginRight : outerMarginH + (col === layout.answerGrid.columns ? 0.5* layout.imagePadding : 0) + 'px',           

            }}
                onClick={() => { clickHandler(); }}>
                {hasImage && <div style={{
                    minHeight: imH,
                    height: imH,
                    maxHeight: imH,
                    minWidth: imW,
                    width: imW,
                    maxWidth: imW,
                    backgroundImage: `url(${currentAnswers[i].image})`,
                    backgroundSize : 'cover',
                    marginLeft : imagePadH + 'px',
                    marginRight : imagePadH + 'px',
                    marginTop : (0.5 * layout.imagePadding) + 'px',
                    marginBottom : (hasText ? 0 : 0.5 * layout.imagePadding) + 'px'
                }}
                    onClick={() => { clickHandler(); }}></div>}
                {hasText &&
                    <span style={{
                        fontSize: layout.answerFontSize + "px", 
                        color : 'white',
                        minWidth : (innerCellWidth - layout.imagePadding) + 'px',
                        width : (innerCellWidth - layout.imagePadding) + 'px',
                        maxWidth : (innerCellWidth - layout.imagePadding) + 'px',
                        textAlign : 'center',
                        marginTop : ((!hasImage) ? onlyTextMarginV :layout.textPadding) + 'px',
                        marginLeft : (layout.imagePadding * 0.5)+ 'px',
                        marginRight : (layout.imagePadding * 0.5) + 'px',

                    }}
                        onClick={() => { clickHandler(); }}>{currentAnswers[i].text}
                    </span>}
            </div>));
        }
        else {

            aGrid.push((<div style={{
                display: 'flex',
                flexDirection: 'row',
                gridColumnStart: col,
                gridColumnEnd : col,
                gridRowStart: row,
                gridRowEnd : row,
                padding: (0.5 * layout.imagePadding) + "px"
            }}>
                {hasImage && <div style={{
                    minHeight: imH,
                    height: imH,
                    maxHeight: imH,
                    minWidth: imW,
                    width: imW,
                    maxWidth: imW,
                    backgroundImage: `url(${currentAnswers[i].image})`,
                }}></div>}
                {(hasText && (!hasImage)) &&
                    <span style={{
                        fontSize: layout.answerFontSize + "px"
                    }}>{currentAnswers[i].text}
                    </span>}

                <div>Slider Here</div>
                { /*<Slider aria-label="Temperature"
                    defaultValue={3}
                    getAriaValueText={(value: number, _index: number) => value + ""}
                    valueLabelDisplay="off"
                    shiftStep={1}
                    step={1}
                    marks
                    min={1}
                    max={5} ></Slider>*/}
            </div>));
        }
    }


    const answers = (<div style={{
        display: "grid",
        gridTemplateRows: "auto",
        gridAutoColumns: "auto",
        minHeight: (layout.height - qHeight) + "px",
        height: (layout.height - qHeight) + "px",
        maxHeight: (layout.height - qHeight) + "px",
        minWidth: layout.width + "px",
        width: layout.width + "px",
        maxWidth: layout.width + "px",
        backgroundColor: '#131313',
    }}>
        {aGrid}
    </div>);

    return answers;

}

type QuizPanelState = 'Landing' | 'Play' | 'Results';

export type QuizPanelProps = { quiz: QuizConfigData, display: QuizPanelDisplayProps, results: QuizResults };

export const QuizPanel = ({ quiz, display, results }: QuizPanelProps): JSX.Element => {

    const uiConfig = React.useContext(UIConfigContext);

    const quizId = React.useRef<string>('');
    const [quizState, setQuizState] = React.useState<QuizPanelState>('Landing');
    const quizEngine = React.useRef<Quiz | null>(null);
    const measureContext = React.useRef<MeasureContext | null>(createMeasureContext(display.fontbase));
    const currentLayout = React.useRef<QuestionLayout | undefined>(undefined);
    const timerCounter = React.useRef<number>(-1);
    const totalTime = React.useRef<number>(0);
    const [renderCount, setRenderCount] = React.useState<number>(0);
    const renderCountRef = React.useRef<number>(0);
    const userRanking = React.useRef<number>(-1);
    const timerFrom = React.useRef<number>(-1);
    const questionNumber = React.useRef<number>(0);

    const answerSelected = React.useRef<number[]>([]);
    const answerValues = React.useRef<number[]>([]);
    if (quizId.current !== quiz.itemId) {
        quizId.current = quiz.itemId;
        quizEngine.current = CreateQuiz(quiz, results);
    }

    const onRankingReturn = (json: any) => {
        userRanking.current = json.position as number;
        renderCountRef.current++;
        setRenderCount(renderCountRef.current);
    }





    const onAnswer = (selected: number[], values: number[]) => {
        if (quizEngine.current !== null) {
            const result = quizEngine.current.AnswerGiven(selected, values, false);
            if(result === 'none'){

            }
            else if (result === 'complete') {
                display.complete(quizEngine.current.Points(), quizEngine.current.Time());
                setQuizState('Results');
            }
            else if (result === 'load-new-question') {
                const qDiv = document.getElementById('QuizQuestionAndAnswerWrapper');
                if (qDiv !== null) {
                    qDiv.style.opacity = '0.0';
                }
                window.setTimeout(() => {
                    renderCountRef.current++;
                    setRenderCount(renderCountRef.current);
                    questionNumber.current = 0;
                    const qDiv = document.getElementById('QuizQuestionAndAnswerWrapper');
                    if (qDiv !== null) {
                        qDiv.style.opacity = '1.0';
                    }
                }, 500);
            }
            else {
                const aDiv = document.getElementById('QuizAnswerWrapper');
                if (aDiv !== null) {
                    aDiv.style.opacity = '0.0';
                }
                window.setTimeout(() => {
                    renderCountRef.current++;
                    setRenderCount(renderCountRef.current);
                    questionNumber.current = 0;
                    const aDiv = document.getElementById('QuizAnswerWrapper');
                    if (aDiv !== null) {
                        aDiv.style.opacity = '0.0';
                    }
                }, 500);

            }
        }
    }



    


    if (quizState === 'Play') {

        if (measureContext.current !== null && quizEngine.current !== null && questionNumber.current !== quizEngine.current.QuestionNumber()) {
            questionNumber.current = quizEngine.current.QuestionNumber();
            console.log('Rendering Question Panel : rc=' + renderCountRef.current + ' time= ' + (timerFrom.current === -1 ? 'NO TIME SET' : ((Date.now() - timerFrom.current)/1000) + ' seconds'));
            const headerHeight = display.headerBar === "none" ? 0 : (display.headerBar === "compact" ? 5 : 1.2 * display.fontbase + display.textPadding);
            currentLayout.current = CreateQuestionLayout(quizEngine.current.CurrentQuestion(), quizEngine.current.CurrentAnswers(), display, uiConfig, measureContext.current, headerHeight);
        }
        if(timerFrom.current === -1){
            timerFrom.current = Date.now();
            timerCounter.current = timerFrom.current;
            window.setInterval(() => {
                if (quizEngine.current !== null && quiz.timerMode !== 'none' && (quizState === 'Play')) {
                    totalTime.current = (Date.now() - timerFrom.current)/1000;
                    console.log('Total Quiz Time : ' + totalTime.current + ' Time Limit :' + quizEngine.current.CurrentTimeLimit() + ' Time From: ' + timerFrom.current + ' Mode: ' + quiz.timerMode);
                    if (quiz.timerMode === "total") {
                        if (totalTime.current >= quizEngine.current.CurrentTimeLimit()){
                            display.complete(quizEngine.current.Points(), quizEngine.current.Time());
                            setQuizState('Results');
                        }
                    }
                    else if(quiz.timerMode === 'question') {
                        const qTime = (Date.now() - timerCounter.current);
                        const timeLimit = quizEngine.current.CurrentTimeLimit();
                        if (qTime >= timeLimit) {
                            const result = quizEngine.current.QuestionTimeOut();
                            timerCounter.current = Date.now();
                            if (result === 'complete'){
                                display.complete(quizEngine.current.Points(), quizEngine.current.Time());
                                setQuizState('Results');
                            }
                            else {
                                const qDiv = document.getElementById('QuizQuestionAndAnswerWrapper');
                                if (qDiv !== null) {
                                    qDiv.style.opacity = '0.0';
                                }
                                window.setTimeout(() => {
                                    renderCountRef.current++;
                                    setRenderCount(renderCountRef.current);
                                    questionNumber.current = 0;
                                    const qDiv = document.getElementById('QuizQuestionAndAnswerWrapper');
                                    if (qDiv !== null) {
                                        qDiv.style.opacity = '1.0';
                                    }
                                }, 500);
                            }
        
                        }
                    }
                }
        
            }, 250);
        }



        if ((currentLayout.current !== null) && (currentLayout.current !== undefined) && (quizEngine.current !== null)) {

            const headerProps: QuizPanelHeaderProps = {
                headerType: display.headerBar,
                questionNumber: quizEngine.current.QuestionNumber(),
                quizTimeMode: quiz.timerMode,
                timeLimit: quizEngine.current.CurrentTimeLimit(),
            }



            return (<div style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: currentLayout.current.height + "px",
                height: currentLayout.current.height + "px",
                maxHeight: currentLayout.current.height + "px",
                minWidth: currentLayout.current.width + "px",
                width: currentLayout.current.width + "px",
                maxWidth: currentLayout.current.width + "px",
                backgroundColor : '#131313'
            }}>
                <QuizPanelHeader {...headerProps} ></QuizPanelHeader>

                <div id='QuizQuestionAndAnswerWrapper' style={{ opacity: 1.0, transition: 'opacity 0.5s', transitionTimingFunction: 'ease-in-out' }}>
                    <QuestionPanel question={quizEngine.current.CurrentQuestion()} layout={currentLayout.current} />
                    <div id='QuizAnswerWrapper' style={{ opacity: 1.0, transition: 'opacity 0.5s', transitionTimingFunction: 'ease-in-out' }}>
                        <AnswerPanel question={quizEngine.current.CurrentQuestion()} currentAnswers={quizEngine.current.CurrentAnswers()} layout={currentLayout.current} onAnswer={onAnswer} />
                    </div>
                </div>
            </div>);
        }
        else {
            return <div></div>;
        }
    }
    else if (quizState === 'Landing') {

        const onEnterParty : ActionHandler= (_action) => {
            setQuizState('Play');
            return true;
        }

        const enterAction = CreateAction('onEnterParty', [], onEnterParty);
        const landingProps: LandingPageProps = {
            height: display.availableHeight,
            showEnterButton: true,
            heading: quiz.title,
            subHeading: quiz.subTitle,
            image: quiz.image === undefined ? '/images/default-quiz-image.png' : quiz.image,
            description: quiz.description,
            buttonText: 'Play Now',
            action : enterAction,
            actionData : EmptyActionData,
            imageProportion : 0.33,
            absolute : false,
            noEntryText : ''
        }
        return <LandingPage {...landingProps} />

    }
    else if(quizEngine.current !== null) {
        const qrProps : QuizResultsPanelProps = {
                height: display.availableHeight,
                image: quiz.image,
                quizType: quiz.quizType,
                quizId: quiz.itemId,
                quizEngine: quizEngine.current,
                numberInParty : display.numberInParty,
                quizOpened : display.quizOpened,
                quizCloses : display.quizCloses,
                partyId : display.partyId, 
                quizConfig : quiz
        }
        return <QuizResultsPanel {...qrProps}/>
        /*const points = quizEngine.current !== null ? quizEngine.current.Points() : 0;
        const timeBonus = quizEngine.current !== null ? quizEngine.current.TimeBonus() : 0;
        const totalPoints = points + timeBonus;
        const time = quizEngine.current !== null ? quizEngine.current.Time() : 0;
        const timeString = Math.floor(time / 60000) + 'minutes and ' + Math.floor((time % 60000) / 1000) + ' seconds';
        if (userRanking.current <= 0 || quiz.scores === undefined) {
            if (userRanking.current === -1) {
                userRanking.current = 0;
                const getRanking = async () => {
                    try {
                        const uri = './api/quizresults';
                        const data = { itemId: quiz.itemId, results: results };
                        const response = await fetch(uri, {
                            method: "POST",
                            headers: { "content-type": "application/json" },
                            body: JSON.stringify(data)
                        });
                        const json = await response.json();
                        onRankingReturn(json);
                    }
                    catch (e) {
                        console.log(e);
                        userRanking.current = Math.floor(0.5 * (quiz.scores !== undefined ? quiz.scores.uniquePlayers : 1046));
                    }
                }
                getRanking();
            }
            return <div style={{maxWidth : display.availableWidth + 'px'}}> You completed the quiz earning {points} points in just {timeString} earning a Time Bonus of {timeBonus} to make a grand total {totalPoints} points</div>
        }
        else {
            return <div style={{display : 'flex', flexDirection : 'column', maxWidth : display.availableWidth + 'px'}}>
                <div> You completed the quiz earning {points} points in just {timeString} earning a Time Bonus of {timeBonus} to make a grand total {totalPoints} points</div>
                {quiz.scores.rankings.map((ranking, index)=> {
                    return <div style={{display : 'flex', flexDirection : 'row'}}>
                        <div style={{minWidth : (display.availableWidth * 0.75) + 'px',maxWidth : (display.availableWidth * 0.75) + 'px' }}>
                            <span>{ '#' + (index+1) + ' : ' + ranking.nickname}</span>
                        </div>
                        <div><span>{ranking.score + 'pts'}</span></div>
                    </div>
                })}
                <div style={{minWidth : (display.availableWidth * 0.75) + 'px',maxWidth : (display.availableWidth * 0.75) + 'px' }}>
                            <span>{'#' + (userRanking.current) + ' :'} You</span>
                        </div>
                        <div><span>{(results.answerPoints + results.timeBonus) + 'pts'}</span></div>
            </div>

        }*/


    }
    else
    return <div></div>



}